<template lang="pug">
table.ui-app-data-table
  tbody
    tr(
      v-for="(item, field) in this.vendor"
      :key="field"
    )
      td
        strong {{ humanize(field) }}
      td(v-if="field === 'bban'" style="white-space:pre") {{bban(item)}}
      td(v-else) {{item}}
</template>

<script>
export default {
  props: ["vendor"],

  methods: {
    humanize(str) {
      return str
        .replace(/^[\s_]+|[\s_]+$/g, "")
        .replace(/[_\s]+/g, " ")
        .replace(/^[a-z]/, function (m) {
          return m.toUpperCase();
        });
    },
    bban(item) {
      let banks = "";
      item.forEach((bank, index) => {
        banks += index+1 + " => Bic: " + bank.bic + "; Bban: " + bank.bban + "; default: " + bank.default + "; currency: " + bank.currency + "\n";
      })

      return banks;
    }
  },
};
</script>
